import { render } from "./mentalHealthCreate.vue?vue&type=template&id=a56b3f56"
import script from "./mentalHealthCreate.vue?vue&type=script&lang=js"
export * from "./mentalHealthCreate.vue?vue&type=script&lang=js"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__